import React, { useState } from 'react'
import { Button } from '@mui/material'
import { useDispatch } from 'react-redux'
import ContainerDetailsContent from './ContainerDetailsContent'
import { getUsers, updateUserRole } from '../../actions/user.actions'
import Loader from '../../components/Loader'
import SelectMultiple from '../ComponentContainer/SelectMultiple'

const EditRoleUserBlock = ({
    userDetails,
    setTypeModal,
    loading
}) => {
    const [selectedCategories, setSelectedCategories] = useState(null);
    const [categoryIds, setCategoryIds] = useState([]);

    const dispatch = useDispatch()

    const handleClick = async () => {
        const payload = {
            id: userDetails._id,
            role: userDetails.role === "partner" ? "user" : "partner"
        };
        await dispatch(updateUserRole(payload));
        dispatch(getUsers());
    };
    if (loading) {
        return (
            <Loader />
        );
    }
    const handleAddCategories = () => {
        console.log("test", test)
    }
    return (
        <ContainerDetailsContent
            setTypeModal={setTypeModal}
            noneButtons
        >
            <div>

                <Button
                    style={{
                        margin: "5px"
                    }}
                    variant='contained'
                    // key={index}
                    onClick={() => handleClick()}
                >
                    Изменить роль с  {userDetails.role} на {userDetails.role === "partner" ? "user" : "partner"}
                </Button>
                <Button
                    style={{
                        margin: "5px"
                    }}
                    variant='contained'
                    // key={index}
                    onClick={() => handleAddCategories()}
                >
                    Открыть категории для пользователя
                </Button>
                {/* {!currentId
                    ?
                     <SelectMultiple
                        items={products}
                        productIds={categoryIds}
                        selectedProduct={selectedCategories}
                        setSelectedProduct={setSelectedCategories}
                        setProductIds={setCategoryIds}
                        topImg="35%"
                        rightImg="15%"
                    />
                    : null
                } */}
            </div>

        </ContainerDetailsContent>
    )
}

export default EditRoleUserBlock